<template>
  <div class="container-alb moverflow">
    <table cellpadding="10" cellspacing="0" width="95%" align="center">
      <tr class="trhover">
        <td valign="middle">
          <strong>{{ $t("orderDetailsProductLabel") }}</strong>
        </td>
        <td valign="middle">
          <span>
            <img
              :src="
                require('@/assets/images/product_' + order.product + '.svg')
              "
            />
            &nbsp;&nbsp;{{ getProductNameMethod(order.product, order.brand) }}
          </span>
        </td>
      </tr>
      <tr class="trhover gri-cell" v-if="order.type !== 'REPL'">
        <td valign="middle">
          <strong>{{ $t("orderDetailsNominalValueLabel") }}</strong>
        </td>
        <td valign="middle">
          <div>
            <p>{{ order.total_nominal_value | toCurrency }}</p>
          </div>
        </td>
      </tr>
      <tr class="trhover" v-if="order.type !== 'REPL'">
        <td valign="middle">
          <strong>{{ $t("orderDetailsCommisionLabel") }}</strong>
        </td>
        <td valign="middle">
          <div>
            <p>{{ order.order_commision | toCurrency }}</p>
          </div>
        </td>
      </tr>
      <tr class="trhover gri-cell">
        <td valign="middle">
          <strong>{{ $t("orderDetailsVatLabel") }}</strong>
        </td>
        <td valign="middle">
          <div>
            <p>{{ order.order_vat | toCurrency }}</p>
          </div>
        </td>
      </tr>
      <tr class="trhover" v-if="order.type !== 'REPL'">
        <td valign="middle">
          <strong>{{ $t("orderDetailsDeliveryFeeLabel") }}</strong>
        </td>
        <td valign="middle">
          <div>
            <p>{{ order.order_delivery_fee | toCurrency }}</p>
          </div>
        </td>
      </tr>
      <tr class="trhover gri-cell" v-if="order.type !== 'REPL'">
        <td valign="middle">
          <strong>{{ $t("orderDetailsCardFeeLabel") }}</strong>
        </td>
        <td valign="middle">
          <div>
            <p>{{ order.order_card_fee | toCurrency }}</p>
          </div>
        </td>
      </tr>
      <tr class="trhover" >
        <td valign="middle">
          <strong>{{ $t("orderDetailsTotalValueLabel") }}</strong>
        </td>
        <td valign="middle">
          <div>
            <p>{{ order.total_amount_value | toCurrency }}</p>
          </div>
        </td>
      </tr>
      <!-- <tr class="trhover">
          <td valign="middle">
            <strong>{{$t('beneficiariesTableSeeMore')}}</strong>
          </td>
          <td valign="middle">
            <a class="download-or-view" @click="viewDetails(true)">
              <img src="@/assets/images/o-d-user.svg" />
            </a>
            &nbsp;&nbsp;
            <a class="download-or-view">
              <img src="@/assets/images/o-d-download.svg" />
            </a>
          </td>
        </tr>-->
      <tr class="trhover gri-cell" v-if="order.type === 'NEW'">
        <td valign="middle">
          <strong>{{ $t("orderDetailsNoCardsLabel") }}</strong>
        </td>
        <td valign="middle">{{ order.total_cards }}</td>
      </tr>
      <tr
        class="trhover gri-cell"
        v-if="order.type === 'NEWCR' && order.product > 10"
      >
        <td valign="middle">
          <strong>{{ $t("orderValidFromLabel") }}</strong>
        </td>
        <td valign="middle">{{ this.getDisplayDate(order.charge_date) }}</td>
      </tr>
      <tr class="trhover gri-cell" v-if="order.type === 'PAPER'">
        <td valign="middle">
          <strong>{{ $t("orderDetailsNoTicketsLabel") }}</strong>
        </td>
        <td valign="middle">{{ order.total_vouchers }}</td>
      </tr>
      <tr class="trhover" v-if="order.type === 'PAPER'">
        <td valign="middle">
          <strong>{{ $t("groupTickets") }}</strong>
        </td>
        <td valign="middle">{{ order.grouping }}</td>
      </tr>
      <tr class="trhover gri-cell" v-if="order.type === 'PAPER'">
        <td valign="middle">
          <strong>{{ $t("messageTicket") }}</strong>
        </td>
        <td valign="middle">{{ order.message }}</td>
      </tr>
      <tr v-if="orderAddresses && orderAddresses.length > 0" class="trhover ">
          <td valign="middle">
            <strong>{{ $t("orderDetailsDeliveryLabel") }}</strong>
          </td>
          <td valign="middle">
            <table >
              <tr v-for="(address, index) in orderAddresses" :key="index">
                <td>{{ address }}</td>
              </tr>
            </table>
          </td>
        </tr>
    </table>
  </div>
</template>

<script>
import utils from "@/plugins/utils.js";
import moment from "moment";
import products from "@/assets/json/products.js";

export default {
  props: {
    order: Object,
    orderAddresses: Array
  },
  methods: {
    getProductNameMethod(product, brand) {
      return utils.getProductByIdAndBrand(product, brand, products).name;
    },
    getDisplayDate(date) {
      return moment(new Date(date), "YYYY-MM-DDThh:mm:ss").format("DD/MM/YYYY");
    },
  },
  computed: {
    isOrderProductReward() {
      return this.order.brand === "rewards";
    },
  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
